
export const page = function( $scope,cartManager,$window,$location,httpManager,loadingManager ) {
    $scope.cartManagerCtrl = cartManager;

    $scope.variants = [];
	$scope.currentVariant = 0;
    $scope.selectedVariant = {};

    $scope.product = null;

    $window.onload = function() {
        loadProducts();
    };

    function loadProducts() {
        var path = $location.absUrl().split('/').reverse();
        if(path[1] == 'products')
            loadProduct(path[0]);
    };

    function getProductCallback(data){
        $scope.product = data.data;
        console.log('Data',data.data);
    }

    function loadProduct(product){
        httpManager.getRequester(window.Shopify.routes.root + `products/${product}.js`,{},false,getProductCallback);
    }

    $scope.loadProduct = (product) => {
        // console.log('Variant',$scope.product);
        // $scope.product = JSON.parse(product);
        // setVariant();
        // httpManager.getRequester(window.Shopify.routes.root + 'cart.js',{},false,getCartItemsCallback);
	};

    function setVariant(){
        if($scope.currentVariant == -1){
            $scope.product.variants.forEach((variant,key)=>{
                if(variant.available && ($scope.currentVariant == 0)){
                    $scope.currentVariant = key;
                }
            });
            console.log('variant',$scope.product.variants);
        }
	}

    $scope.selectVariant = function(optionName,optionType){
        // if($scope.product != null){
            console.log('Initital',optionName,optionType,$scope.product.options);
            var availableOptions = $scope.product.options;
            var currentOptionIndex = -1;
            availableOptions.forEach((option,key) => {
                if(option.name == optionType){
                    currentOptionIndex = key;
                }
            });

            console.log('CurrentOptionIndex', currentOptionIndex);

            var nameExploded = $scope.product.variants[$scope.currentVariant].title.split(' / ');
            console.log('Options',nameExploded);
            nameExploded[currentOptionIndex] = optionName;
            console.log('Option Name',optionName);
            var newName = nameExploded.join(' / ');
            console.log('Options',newName);

            $scope.product.variants.forEach((variant,key) => {
                if(variant.title == newName && variant.available){
                    $scope.currentVariant = key;
                }
            });
            console.log('CurrentVariant',$scope.currentVariant);
            console.log('CurrentOptionIndex', $scope.product.variants[$scope.currentVariant].featured_image.src);

            $scope.product.images.forEach((image,key) => {
                if(image == $scope.product.variants[$scope.currentVariant].featured_image.src){
                    chooseSlideIndex(key);
                }
            });

            console.log('CurrentVariant',$scope.currentVariant);
        // }
    };

    $scope.addToCart = (shouldShowCart) => {
        console.log('Current Variant 2',$scope.currentVariant);
        var id = -1;
        if($scope.product.variants.length == 1)
            id = $scope.product.variants[0].id;
        else
            id = $scope.product.variants[$scope.currentVariant].id;

        $scope.cartManagerCtrl.addToCart(id,shouldShowCart);
    }

    $scope.removeFromCart = (line) => {
        $scope.cartManagerCtrl.changeCart(line,0);
    }
        
    $scope.selectedVariantCheck = (value) => {
        var selected = false ;
        // if($scope.product != null){
            if($scope.product.variants[$scope.currentVariant] != undefined){
                $scope.product.variants[$scope.currentVariant].options.forEach(variant => {
                    if(variant == value)
                        selected = true;
                });
            }
        // }
        return selected;
    };

    $scope.validPass = () => {
        var passcode = localStorage.getItem('sd_passcode');
        console.log('passcode',passcode);
        return (passcode == undefined);
        // return false;
    }

    //////////////////////////////////////////////////////////////

    $scope.interestSubmitted = false;

    $scope.disabled = '';

    if(localStorage.getItem('querySubmitted') != null)
        $scope.disabled = 'disabled';

    $scope.form = { name : { value: '' , pattern: /^[a-zA-Z ,.'-]+$/ } , email_id : { value: '' , pattern: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i } };

    $scope.checkFieldValidity = (name) => {
        return $scope.form[name].value.length > 0 ? (checkValidity(name) ? 'is-valid' : 'is-invalid') : '';
    };

    function checkValidity(name){
        return $scope.form[name].pattern.test($scope.form[name].value);
    };

    function resetForm(){
        for(const field in $scope.form)
            $scope.form[field].value = '';
    }
    
    $scope.addressValid = () => {
        for(const field in $scope.form) {
            if(!!$scope.form[field].pattern){
                if(!checkValidity(field)){
                    return 'disabled';
                }
            }
        }
        return '';
    };

    function stripForm(form){
        var minimalistForm = {};
        for(const field in form) {
            minimalistForm[field] = form[field].value;
        }
        return minimalistForm;
    }

    $scope.requestCallback = () => {
        console.log(stripForm($scope.form));
        var apiUrl = "https://api.binarydharma.online/simmydoo/emailaccess";
        // var apiUrl = "http://localhost/master-api/simmydoo/requestcallback";
        // loadingManager.show('Submitting your details...');
        fetch(apiUrl, {
            method: "POST",
            body: JSON.stringify(stripForm($scope.form)),
            headers: { "Content-type": "application/json; charset=UTF-8" , 'Access-Control-Allow-Origin': '*' }
        }).then((response) => {
            // loadingManager.hide();
            $scope.interestSubmitted = true;
            $scope.disabled = 'disabled';
            resetForm();
            document.getElementsByTagName('body')[0].classList.remove('show');
            $scope.$apply();
            localStorage.setItem('querySubmitted','true');
            
        }).catch((error) => {
            document.getElementsByTagName('body')[0].classList.remove('show');
        });
    };

    function showLoading(token){
        console.log(document.getElementsByTagName('body')[0].classList.add('show'));
        setTimeout(()=>{
            document.getElementsByTagName('body')[0].classList.remove('show')
        },3000);
    }

    ////////////////////////////////////////////////////////////////////////////////////////

    $scope.showQuickView = (product) =>{
        console.log('Prodct',product)
    };

    ////////////////////////////////////////////////////////////////////////////////////////

    $scope.swatchColors = [
        { name : 'Kole' , hex : '#000' },
        { name : 'Gulabo' , hex : 'pink' },
        { name : 'Rainbow' , hex : 'linear-gradient(180deg, red, orange, yellow, green, blue, indigo, violet)' },
    ];

    $scope.selectedCustomisationColor = $scope.swatchColors[0].name;

    $scope.customisationForm = { name : { value: '' , pattern: /^[a-zA-Z ,.'-]+$/ } , color : { value: '' , pattern: /^[a-zA-Z ,.'-]+$/ } };

    $scope.checkCustomisationFieldValidity = (name) => {
        return $scope.customisationForm['name'].value.length > 0 ? (checkCustomisedValidity('name') ? 'is-valid' : 'is-invalid') : '';
    }

    function checkCustomisedValidity(){
        return $scope.customisationForm['name'].pattern.test($scope.customisation['name'].value);
    };

    $scope.selectedCustomisationVariantCheck = (value) => {
        var selected = false ;
        return selected;
    };

    $scope.selectSwatch = (name) => {
        $scope.selectedCustomisationColor = name;
    };

    $scope.addCustomisation = () => {
        var id = 0;
        if($scope.product.variants.length == 1)
            id = $scope.product.variants[0].id;
        else
            id = $scope.product.variants[$scope.currentVariant].id;

        var properties = { 'name' : $scope.customisationForm['name'].value , 'color' : $scope.selectedCustomisationColor };
        console.log('Properties',properties);
        $scope.cartManagerCtrl.addToCart(id,true,properties);
    }
};